import Header from "../../components/dashboard/header";
import {Breadcrumb, Button, Form, Input, message, Modal, Popconfirm, Select, Space, Spin} from "antd";
import {DashboardOutlined, DeleteOutlined, EditOutlined, PlusSquareOutlined} from "@ant-design/icons";
import {Link} from "react-router-dom";
import {AiOutlineSetting} from "react-icons/ai";
import {TbFileSettings} from "react-icons/tb";
import UploadButton from "../../components/common/uploadButton";
import DataTable from "../../components/common/table";
import {useEffect, useRef, useState} from "react";
import {INFLOW, OUTFLOW} from "../../shared/flowType";
import {
    useCreateBudgetCategory, useDeleteBudgetCategory,
    useGetAllBudgetCategories,
    useUpdateBudgetCategory
} from "../../hooks/budgetCategory/budgetCategoryQuery";
import {extractValueFromInputRef} from "../../helpers/dom";

const { Option } = Select
const eventBus = document


const categoryColumns = [
    {
        title:'S/N',
        dataIndex:'id',
        key:'id',
        render:(_,__,idx)=>idx+1
    },
    {
        title:"Title",
        dataIndex:"title",
        key:"title"
    },
    {
        title:'Value',
        dataIndex:'value',
        key:'value'
    },
    {
        title:'Type',
        dataIndex:'flow',
        key:'flow'
    },
    {
        title:'Action',
        key:'action',
        render:(_,item)=>(
            <EditCategory category={item}/>
        )
    }
]


const flows = [INFLOW, OUTFLOW]

function EditCategory({category}){
    const titleRef = useRef(null)
    const valueRef = useRef(null)
    const [isOpen, setIsOpen] = useState(false)
    const [loading, setLoading] = useState(false)
    const [selectedFlow, setSelectedFlow] = useState(null)
    const [updating, setUpdating] = useState(false)

    const updateRecord = useUpdateBudgetCategory()
    const deleteRecord = useDeleteBudgetCategory()

    const showCreateModal = () => setIsOpen(true)
    const hideCreateModal = () => setIsOpen(false)

    const handleDelete = async () => {
        const d = await deleteRecord(category.id)
        message.success("Deleted successfully")
    }

    const handleSubmit = async () => {
        // create
        setUpdating(true)
        const data = await updateRecord(category.id, {
            title: extractValueFromInputRef(titleRef),
            value: extractValueFromInputRef(valueRef),
            flowType: selectedFlow
        })

        message.success("item updated successfully")
        setUpdating(false)
        hideCreateModal()
    }

    return (
        <>
            <Space size="small" wrap>
                <Button type="primary" onClick={showCreateModal}>
                    <EditOutlined />
                    Edit
                </Button>
                <Popconfirm
                    title="Delete this account type"
                    description="Are you sure to delete this category?"
                    onConfirm={handleDelete}
                    onCancel={()=>null}
                    okText="Yes"
                    cancelText="No"
                >
                    <Button type="primary" danger>
                        <DeleteOutlined />
                        Delete
                    </Button>
                </Popconfirm>
            </Space>
                <Modal open={isOpen} footer={null} onCancel={hideCreateModal} title="Edit budget category">
                    <Form initialValues={{...category}}>
                        <Form.Item name='title'>
                            <Input type="text" ref={titleRef} placeholder="Enter title"/>
                        </Form.Item>
                        <Form.Item name="value">
                            <Input type="text" ref={valueRef} placeholder="Enter value"/>
                        </Form.Item>
                        <Form.Item name="flow">
                            <Select placeholder="Select flow type" onChange={e => setSelectedFlow(e)}>
                                {
                                    flows.map((fl, idx) => (
                                        <Option value={fl.value} key={idx}>
                                            {fl.name}
                                        </Option>
                                    ))
                                }
                            </Select>
                        </Form.Item>
                        <Form.Item
                            wrapperCol={{
                                span:8,
                                offset:20
                            }}
                            className="submit-button-wrapper"
                        >
                            <Button loading={updating} style={{backgroundColor:"green"}} size="large" type="primary" htmlType="submit" onClick={handleSubmit}>
                                Update
                            </Button>
                        </Form.Item>
                    </Form>
                </Modal>
        </>
    )
}

export default function BudgetCategory(){

    const [categories, setCategories] = useState([])
    const [isOpen, setIsOpen] = useState(false)
    const [loading, setLoading] = useState(false)
    const [creating, setCreating] = useState(false)
    const titleRef = useRef(null)
    const valueRef = useRef(null)
    const [selectedFlow, setSelectedFlow] = useState(null)
    const [edit, setEdit] = useState(null)

    const fetchRecords = useGetAllBudgetCategories()
    const createRecord = useCreateBudgetCategory()

    const showCreateModal = () => setIsOpen(true)
    const hideCreateModal = () => setIsOpen(false)

    const loadData = async () => {
        const data = await fetchRecords()
        setCategories(data)
    }

    const handleSubmit = async () => {
        // create
        setCreating(true)
        const data = await createRecord({
            title: extractValueFromInputRef(titleRef),
            value: extractValueFromInputRef(valueRef),
            flowType: selectedFlow
        })

        const d = categories
        d.push(data)
        setCategories(d)
        message.success("item added successfully")
        setCreating(false)
        hideCreateModal()
        await loadData()
    }

    useEffect( () => {
        loadData()
    }, []);

    return(
        <>
            <div className="main-container">
                <Header/>
                <div className="main-body">

                    <div className="info-bar">
                        <Breadcrumb>
                            <Breadcrumb.Item>
                                <DashboardOutlined className="dashboard-icon"/>
                                <Link to={"/dashboard"}>Dashboard</Link>
                            </Breadcrumb.Item>
                            <Breadcrumb.Item>
                                <AiOutlineSetting/>
                                <Link to={"/dashboard"}>Configuration</Link>
                            </Breadcrumb.Item>
                            <Breadcrumb.Item>
                                <TbFileSettings />
                                <Link to="/dashboard/budget-category">Account Type Category</Link>
                            </Breadcrumb.Item>
                        </Breadcrumb>
                        <div style={{display:'flex',gap:'1em'}}>
                            <UploadButton/>
                            <Button style={{backgroundColor:"green",color:"#FFFFFF"}} onClick={showCreateModal}>
                                <PlusSquareOutlined />
                                Add Category
                            </Button>
                        </div>
                    </div>

                    <div className="table-section">
                        <Spin spinning={loading}>
                            <DataTable cols={categoryColumns} data={categories}/>
                        </Spin>
                    </div>
                </div>
            </div>
            <Modal open={isOpen} title={'Add Categories'} footer={null} onCancel={hideCreateModal}>
                <Form>
                    <Form.Item name='title'>
                        <Input type="text" ref={titleRef} placeholder="Enter title"/>
                    </Form.Item>
                    <Form.Item name="value">
                        <Input type="text" ref={valueRef} placeholder="Enter value"/>
                    </Form.Item>
                    <Form.Item name="flowType">
                        <Select placeholder="Select flow type" onChange={e => setSelectedFlow(e)}>
                            {
                                flows.map((fl, idx) => (
                                    <Option value={fl.value} key={idx}>
                                        {fl.name}
                                    </Option>
                                ))
                            }
                        </Select>
                    </Form.Item>
                    <Form.Item
                        wrapperCol={{
                            span:8,
                            offset:20
                        }}
                        className="submit-button-wrapper"
                    >
                        <Button loading={creating} style={{backgroundColor:"green"}} size="large" type="primary" htmlType="submit" onClick={handleSubmit}>
                            Create
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}
